import RenderGenericChildren from './RenderGenericChildren';

export default RenderGenericChildren;
